
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 7h-14A1.5 1.5 0 007 8.5v14A1.5 1.5 0 008.5 24h14a1.5 1.5 0 001.5-1.5v-14A1.5 1.5 0 0022.5 7zm.5 1.5v2.67H12.17V8H22.5a.5.5 0 01.5.5zM8.5 8h2.67v3.17H8V8.5a.5.5 0 01.5-.5zM8 22.5V12.17h3.17V23H8.5a.5.5 0 01-.5-.5zm14.5.5H12.17V12.17H23V22.5a.5.5 0 01-.5.5zM4.75 13.07a.76.76 0 00-.7.5L.56 23.15a.71.71 0 00-.04.22.69.69 0 00.68.7.67.67 0 00.62-.42l.82-2.45.06-.17h3.33V20H3.06l.1-.33 1.65-4.95.06-.17h.38l.05.17.73 2.22v-3.52a.74.74 0 00-.63-.35z"}}),_c('path',{attrs:{"d":"M7.16 5.68L5.62 4.11a.5.5 0 00-.76.04L1 9.1V1.5a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v4a.5.5 0 001 0v-4A1.5 1.5 0 0015.5 0h-14A1.5 1.5 0 000 1.5v8a1.49 1.49 0 00.4 1c0 .02 0 .04.02.05a1.37 1.37 0 001.01.46h4.08a.5.5 0 00.5-.5v-.3a.5.5 0 00-.5-.5H1.8l3.5-4.5 1.14 1.17a.5.5 0 10.71-.7z"}}),_c('circle',{attrs:{"cx":"12.94","cy":"3.46","r":".75"}})])
          )
        }
      }
    